import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PitchSelectVideoPlayer } from '@/components/video/PitchSelectVideoPlayer';
import { useRightPanelHeader } from '@/hooks/useRightPanelHeader/useRightPanelHeader';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';

export const PitchSelectVideoPreview = () => {
  const { t } = useTranslation('video');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);

  useRightPanelHeader(t('player'), () => navigate(`..?${updateQueryString([], undefined)}`));

  return <PitchSelectVideoPlayer />;
};
